import { ChangeDetectionStrategy, Component, Input, inject } from '@angular/core';

import { Router } from '@angular/router';
// import { UpdateService } from './services/update.service';

import { Button } from 'primeng/button';
import { ProgressBar } from 'primeng/progressbar';
import { EventLevel } from '../../../event-level.enum';
import { EventLog } from '../../../event-log';
import { EventStatus } from '../../../event-status.enum';
import { SummitNotificationService } from '../../s-notification.service';

@Component({
  selector: 'summit-notification',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './notification-item.component.html',
  styleUrls: ['./notification-item.component.scss'],
  standalone: true,
  imports: [ProgressBar, Button]
})
export class NotificationItemComponent {
  protected notificationService: SummitNotificationService;
  // protected updateServices: UpdateService;

  constructor(
    public router: Router // private updateServices: UpdateService
  ) {
    this.notificationService = inject(SummitNotificationService);
    // this.updateServices = inject(UpdateService);
  }
  @Input() toastData: EventLog;
  // data?: EventLog;

  getEventLevelIcon() {
    // if (this.data) {
    //   switch (this.data?.eventLevel) {
    //     case EventLevel.Informational:
    //       return 'info';
    //     //  break;
    //     case EventLevel.Warning:
    //       return 'warning';
    //     //  break;
    //     case EventLevel.Alert:
    //       return 'error';
    //     //  break;
    //     case EventLevel.System:
    //       return 'build';
    //     //  break;
    //     case EventLevel.Unknown:
    //     default:
    //       return 'help';
    //     //  break;
    //   }
    // }
    // if (this.toastData) {
    switch (this.toastData.eventLevel) {
      case EventLevel.Informational:
        return 'info';
      //  break;
      case EventLevel.Warning:
        return 'warning';
      //  break;
      case EventLevel.Alert:
        return 'error';
      //  break;
      case EventLevel.System:
        return 'build';
      //  break;
      case EventLevel.Unknown:
      default:
        return 'help';
      //  break;
    }
    // }
  }

  getEventStatusIcon() {
    let response: string;
    // if (this.data) {
    //   switch (this.data?.status) {
    //     case EventStatus.InProgress:
    //       response = 'autorenew';
    //       break;
    //     case EventStatus.Waiting:
    //       response = 'query_builder';
    //       break;
    //     case EventStatus.Failed:
    //       response = 'error';
    //       break;
    //     case EventStatus.Complete:
    //       response = 'check_circle';
    //       break;
    //     case EventStatus.Unknown:
    //     default:
    //       response = 'help';
    //       break;
    //   }
    //   // console.log(`Returning Status Icon of: ${response} for ${this.data.status}`);
    //   return response;
    // }
    // if (this.toastData) {
    switch (this.toastData.status) {
      case EventStatus.InProgress:
        response = 'autorenew';
        break;
      case EventStatus.Waiting:
        response = 'query_builder';
        break;
      case EventStatus.Failed:
        response = 'error';
        break;
      case EventStatus.Complete:
        response = 'check_circle';
        break;
      case EventStatus.Unknown:
        response = '';
        break;
      default:
        response = 'help';
        break;
    }
    // console.log(`Returning Status Icon of: ${response} for ${this.data.status}`);
    return response;
    // }
  }

  isInProgress() {
    // if (this.data) return this.data.status === EventStatus.InProgress;
    return this.toastData.status === EventStatus.InProgress;
    // return this.data?.status === EventStatus.InProgress;
  }
  navAndClear(urlLink: string) {
    console.log(`Navigating to ${urlLink} and clearing`);
    this.router.navigateByUrl(urlLink);
    this.notificationService?.clear();
  }
}
